import ApiClient from '../ApiClient';

// Lightweight agent-safe endpoint: returns only { id, name } for active projects.
// Used by Kanban and Calendar filter dropdowns.
class NexceoProjectOptionsAPI extends ApiClient {
  constructor() {
    super('nexceo/project_options', { accountScoped: true });
  }
}

export default new NexceoProjectOptionsAPI();
